export default __webpack_public_path__ + "static/media/logoNav.54308a5d.png";